import React from 'react'
import Excel1 from './excel1'
import Excel3 from './excel3'
import ExcelHtml from './excelHtml'
import { removeHtmlTags } from '../../util'

const DownloadExcel = (props) => {
  const {
    downloadId,
    downloadPptData,
    InsightsElementType,
    downloadIdData,
    Title,
    buttonName = 'Excel',
  } = props

  const ImagesTypeExcelArray = ['CustomImage', 'ResearchDesign__']
  const insightsHeading = removeHtmlTags(props?.Heading || '')
    .replaceAll('/', ' ')
    .replaceAll('&lt;', '')
    .replaceAll('p&gt;', '')
    .replaceAll('&lt;', '')
    .replaceAll('p&gt;', '')
    .replaceAll('-', ' ')
    .replaceAll(':', ' ')

  const drivers = [
    'SearchDrivers',
    'DriversAndSubBrands',
    'DriversWithoutSentimentsAndSubBrands',
    'DriversAndTriggers',
    'DriversAndRatingImpacts',
    'Drivers',
    'DriversWithoutSentiments',
    'DriversAndSubBrandsMotivatorsDetractors',
    'DriversAndTriggersMotivatorsDetractors',
    'DriversAndRatingImpactsMotivatorsDetractors',
    'DriversMotivatorsDetractors',
    'DriversWithoutSentimentsMotivatorsDetractors',
  ]
  const segments = [
    'SegmentDriversAnalysis',
    'DriversProgression',
    'DriversProgressionWithoutSentiments',
    'SearchDriversProgression',
    'Triangulation',
    'TriangulationComparisonViewOnly',
    'SegmentDriversOnlyAnalysis',
  ]
  const mining = [
    'InsightsMiningFrameworkWithSentiments',
    'InsightsMiningFrameworkWithoutSentiments',
  ]
  const mix = [
    'ImpactDestinations',
    'ImpactDestinationsAndProgression',
    'BusinessObjective',
    'Recommendation',
    'RecommendationAndProgression',
    'Aura',
    'AuraWithoutSentiments',
    'AuraAndProgression',
    'AuraAndComparison',
    'AuraAndProgressionAndComparison',
    'AuraWithoutSentimentsAndProgression',
    'AuraWithoutSentimentsAndComparison',
    'AuraWithoutSentimentsAndProgressionAndComparison',
    'BrandCategoryOverview',
    'BrandCategoryOverviewAndProgression',
    'BrandImageryMappingGraph',
    'BrandImageryMappingAndProgressionGraph',
    'BrandImageryMappingTable',
    'CampaignTriggers',
    'CampaignAndIssuesAssessmentSetup',
    'FactorInterlinkage',
    'CategoryPersona'
  ]
  const triangulations = [
    'BrandAttributeMapElement',
    'BrandAttributeMapAndProgression',
    'TriangulationMapElement',
    'TriangulationMapAndProgression',
    'TriangulationMapElementLog10',
    'TriangulationMapAndProgressionLog10',
  ]
  const segmentation = [
    'SegmentOfSegmentOverviewAndProgression',
    'SegmentOfSegmentOverview',
    'SegmentOfSegmentOverview20Colors',
    'SegmentAndSegmentOfSegment',
    'SegmentAndSegmentProgression',
    'SegmentProgressionOverview',
    'SegmentDriversOnlyAnalysis3Level',
    'SegmentDriversOnlyAnalysisWithoutSentiments',
    'SegmentDriversOnlyAnalysisWithoutSentiments3Level',
    'SearchDriversProgression3Level_v1',
    'SearchDriversProgression3Level',
    'DriversProgression3Level_v1',
    'DriversProgression3Level',
    'DriversProgressionWithoutSentiments3Level_v1',
    'DriversProgressionWithoutSentiments3Level',
  ]
  const nameValueObjects = [
    'SegmentOverview',
    'TopRelativeBrandsAnalysis',
    'AllRelativeBrandsAnalysis',
    'CompetitiveLandscape',
    'CompetitiveLandscapeBrandImagery',
    'CustomTable',
    'BuzzMetrics',
    'ProductRatingOptimizationSetup',
    'BrandHealthSetup',
    'BrandMagnetScore',
    'BrandMagnetScoreAndProgression',
    'CategoryExplorationSetup',
    'MultiBrandNPS',
  ]
  const ContentExcelArray = [
    ...mix,
    ...drivers,
    ...segments,
    ...mining,
    ...segmentation,
    ...nameValueObjects,
    ...triangulations,
  ]

  return (
    <>
      {downloadId && ImagesTypeExcelArray.includes(InsightsElementType) ? (
        <ExcelHtml downloadId={downloadId} buttonName={buttonName} />
      ) : // : ContentExcelArray.includes(InsightsElementType) ? <Excel3 type={InsightsElementType} data={downloadPptData || downloadIdData} downloadId={downloadId} /> : <Excel1 downloadId={downloadId} />
      ContentExcelArray.includes(InsightsElementType) ? (
        <Excel3
          title={insightsHeading || Title}
          type={InsightsElementType}
          data={downloadIdData}
          downloadId={downloadId}
          buttonName={buttonName}
          tabId={props.TabId}
          parentTitle={props?.ParentTitle || ''}
          mainTitle={Title || insightsHeading}
          InsightsElementId={props.InsightsElementId}
        />
      ) : (
        <Excel1 downloadId={downloadId} buttonName={buttonName} />
      )}
      {/* {downloadId && <Excel1 downloadId={downloadId} />} */}
    </>
  )
}

export default DownloadExcel
